import {createRouter, createWebHistory} from 'vue-router';
import SignIn from '@/views/pages/pages/authentication/login/sign-in.vue'
import SignIn_2 from '@/views/pages/pages/authentication/login/signin-2.vue'
import SignIn_3 from '@/views/pages/pages/authentication/login/signin-3.vue'
import Email_Verification from '@/views/pages/pages/authentication/email-verification/email-verification.vue'
import Email_Verification_2 from '@/views/pages/pages/authentication/email-verification/email-verification-2.vue'
import Email_Verification_3 from '@/views/pages/pages/authentication/email-verification/email-verification-3.vue'
import Two_Step_Verification from '@/views/pages/pages/authentication/two-step-verification/two-step-verification.vue'
import Two_Step_Verification_2 from '@/views/pages/pages/authentication/two-step-verification/two-step-verification-2.vue'
import Two_Step_Verification_3 from '@/views/pages/pages/authentication/two-step-verification/two-step-verification-3.vue'
import Forgot_Password from '@/views/pages/pages/authentication/forgot-password/forgot-password.vue'
import Forgot_Password_2 from '@/views/pages/pages/authentication/forgot-password/forgot-password-2.vue'
import Forgot_Password_3 from '@/views/pages/pages/authentication/forgot-password/forgot-password-3.vue'
import Reset_Password from '@/views/pages/pages/authentication/reset-password/reset-password.vue'
import Reset_Password_2 from '@/views/pages/pages/authentication/reset-password/reset-password-2.vue'
import Reset_Password_3 from '@/views/pages/pages/authentication/reset-password/reset-password-3.vue'
import Lock_Screen from '@/views/pages/pages/authentication/lock-screen.vue'
import Coming_Soon from '@/views/pages/pages/coming-soon.vue'
import Under_Maintenance from '@/views/pages/pages/under-maintenance.vue'
import Error from '@/views/pages/pages/error/error.vue'
import Error_404 from '@/views/pages/pages/error/error-404.vue'
import Error_500 from '@/views/pages/pages/error/error-500.vue'
import Dashboard from '@/views/pages/dashboard/dashboard.vue'
import AdminDashboard from '@/views/pages/dashboard/admin-dashboard.vue'
import SalesDashboard from '@/views/pages/dashboard/sales-dashboard.vue'
import Chat from '@/views/pages/application/chat/chat.vue'
import Call from '@/views/pages/application/call/call.vue'
import VideoCall from '@/views/pages/application/call/video-call.vue'
import AudioCall from '@/views/pages/application/call/audio-call.vue'
import CallHistory from '@/views/pages/application/call/call-history.vue'
import Calendar from '@/views/pages/application/calendar.vue'
import Register from '@/views/pages/pages/authentication/register/register.vue'
import Register_2 from '@/views/pages/pages/authentication/register/register-2.vue'
import Register_3 from '@/views/pages/pages/authentication/register/register-3.vue'
import Blank_Page from '@/views/pages/pages/blank-page.vue'
import Tables from '@/views/pages/uiinterface/tables/tables'
import Tables_Basic from '@/views/pages/uiinterface/tables/tables-basic.vue'
import Data_Tables from '@/views/pages/uiinterface/tables/data-tables.vue'
import Chartapex from '@/views/pages/uiinterface/charts/apex/chart-apex.vue'
import Chartc3 from '@/views/pages/uiinterface/charts/c3/chart-c3.vue'
import Chartflot from '@/views/pages/uiinterface/charts/flot/chart-flot.vue'
import Chartjs from '@/views/pages/uiinterface/charts/js/chart-js.vue'
import Chartmorris from '@/views/pages/uiinterface/charts/morris/chart-morris.vue'
import Charts from '@/views/pages/uiinterface/charts/charts.vue'
import Forms from '@/views/pages/uiinterface/forms/forms.vue'
import Formbasicinput from '@/views/pages/uiinterface/forms/form-elements/formbasic/formbasicinput.vue'
import Formcheckboxradios from '@/views/pages/uiinterface/forms/form-elements/form-checkbox-radios.vue'
import Formgridgutters from '@/views/pages/uiinterface/forms/form-elements/form-grid-gutters.vue'
import Formselect from '@/views/pages/uiinterface/forms/form-elements/form-select.vue'
import FormInput from '@/views/pages/uiinterface/forms/form-elements/forminput/forminput.vue'
import Formmask from '@/views/pages/uiinterface/forms/form-elements/formmask/formmask.vue'
import Formfileupload from '@/views/pages/uiinterface/forms/form-elements/formfileupload.vue'
import FormHorizontal from '@/views/pages/uiinterface/forms/layouts/form-horizontal.vue'
import Formvertical from '@/views/pages/uiinterface/forms/layouts/form-vertical.vue'
import Formfloatinglabels from '@/views/pages/uiinterface/forms/layouts/form-floating-labels.vue'
import Formvalidation from '@/views/pages/uiinterface/forms/form-validation.vue'
import Formselect2 from '@/views/pages/uiinterface/forms/form-select2.vue'
import Formwizard from '@/views/pages/uiinterface/forms/form-wizard.vue'
import Advancedui from '@/views/pages/uiinterface/advancedUI/advancedui.vue'
import UI_Ribbon from '@/views/pages/uiinterface/advancedUI/ui-ribbon.vue'
import UI_Clipboard from '@/views/pages/uiinterface/advancedUI/ui-clipboard.vue'
import UI_Drag_Drop from '@/views/pages/uiinterface/advancedUI/ui-drag-drop.vue'
import UI_Text_Editor from '@/views/pages/uiinterface/advancedUI/ui-text-editor.vue'
import UI_Counter from '@/views/pages/uiinterface/advancedUI/ui-counter.vue'
import UI_Scrollbar from '@/views/pages/uiinterface/advancedUI/ui-scrollbar.vue'
import UI_Rating from '@/views/pages/uiinterface/advancedUI/ui-rating.vue'
import UI_Stickynote from '@/views/pages/uiinterface/advancedUI/ui-stickynote.vue'
import UI_Timeline from '@/views/pages/uiinterface/advancedUI/ui-timeline.vue'
import BaseUi from '@/views/pages/uiinterface/baseui/baseui.vue'
import UI_Alerts from '@/views/pages/uiinterface/baseui/ui-alerts.vue'
import UI_Accordion from '@/views/pages/uiinterface/baseui/ui-accordion.vue'
import UI_Avatar from '@/views/pages/uiinterface/baseui/ui-avatar.vue'
import UI_Badges from '@/views/pages/uiinterface/baseui/ui-badges.vue'
import UI_Borders from '@/views/pages/uiinterface/baseui/ui-borders.vue'
import UI_Buttons from '@/views/pages/uiinterface/baseui/ui-buttons.vue'
import UI_Buttons_group from '@/views/pages/uiinterface/baseui/ui-buttons-group.vue'
import UI_Breadcrumb from '@/views/pages/uiinterface/baseui/ui-breadcrumb.vue'
import UI_Cards from '@/views/pages/uiinterface/baseui/ui-cards.vue'
import UI_Carousel from '@/views/pages/uiinterface/baseui/carousel/ui-carousel.vue'
import UI_Colors from '@/views/pages/uiinterface/baseui/ui-colors.vue'
import UI_Dropdowns from '@/views/pages/uiinterface/baseui/ui-dropdowns.vue'
import UI_Grid from '@/views/pages/uiinterface/baseui/ui-grid.vue'
import UI_Images from '@/views/pages/uiinterface/baseui/ui-images.vue'
import UI_Lightbox from '@/views/pages/uiinterface/baseui/lightbox/ui-lightbox.vue'
import UI_Media from '@/views/pages/uiinterface/baseui/ui-media.vue'
import UI_Modals from '@/views/pages/uiinterface/baseui/ui-modals.vue'
import UI_Offcanvas from '@/views/pages/uiinterface/baseui/ui-offcanvas.vue'
import UI_Pagination from '@/views/pages/uiinterface/baseui/ui-pagination.vue'
import UI_Popovers from '@/views/pages/uiinterface/baseui/ui-popovers.vue'
import UI_Progress from '@/views/pages/uiinterface/baseui/ui-progress.vue'
import UI_Placeholders from '@/views/pages/uiinterface/baseui/ui-placeholders.vue'
import UI_Rangeslider from '@/views/pages/uiinterface/baseui/ui-rangeslider.vue'
import UI_Spinner from '@/views/pages/uiinterface/baseui/ui-spinner.vue'
import UI_Sweetalerts from '@/views/pages/uiinterface/baseui/ui-sweetalerts.vue'
import UI_Tooltips from '@/views/pages/uiinterface/baseui/ui-tooltips.vue'
import UI_Typography from '@/views/pages/uiinterface/baseui/ui-typography.vue'
import UI_Video from '@/views/pages/uiinterface/baseui/ui-video.vue'
import Icons from '@/views/pages/uiinterface/icons/icons.vue'
import UI_Iconfontawesome from "@/views/pages/uiinterface/icons/icon-fontawesome.vue";
import UI_Iconfeather from "@/views/pages/uiinterface/icons/icon-feather.vue";
import UI_Iconionic from "@/views/pages/uiinterface/icons/icon-ionic.vue";
import UI_Iconmaterial from "@/views/pages/uiinterface/icons/icon-material.vue";
import UI_Iconpe7 from "@/views/pages/uiinterface/icons/icon-pe7.vue";
import UI_Iconsimpleline from "@/views/pages/uiinterface/icons/icon-simpleline.vue";
import UI_Iconthemify from "@/views/pages/uiinterface/icons/icon-themify.vue";
import UI_Iconweather from "@/views/pages/uiinterface/icons/icon-weather.vue";
import UI_Icontypicon from "@/views/pages/uiinterface/icons/icon-typicon.vue";
import UI_Iconflag from "@/views/pages/uiinterface/icons/icon-flag.vue";
import Email from '@/views/pages/application/email.vue'
import Todo from '@/views/pages/application/todo.vue'
import Notes from '@/views/pages/application/notes.vue'

// import Inventory from '@/views/pages/inventory/inventory.vue'
// import Low_Stocks from '@/views/pages/inventory/low-stocks/low-stocks.vue'
import Category_List from '@/views/pages/inventory/students.vue'
import Sub_Categories from '@/views/pages/inventory/classes.vue'
// import Brand_List from '@/views/pages/inventory/brand-list.vue'
// import Units from '@/views/pages/inventory/units.vue'
// import Varriant_Attributes from '@/views/pages/inventory/varriant-attributes.vue'
// import Warranty from '@/views/pages/inventory/warranty.vue'
// import Barcode from '@/views/pages/inventory/barcode.vue'
// import Qrcode from '@/views/pages/inventory/qrcode.vue'
// import Product_Details from '@/views/pages/inventory/product-details.vue'
// import Product_List from '@/views/pages/inventory/product-list/product-list.vue'
// import Add_Product from '@/views/pages/inventory/add-product.vue'
// import Edit_Product from '@/views/pages/inventory/edit-product.vue'
// import Expired_Products from '@/views/pages/inventory/expired-products.vue'

import Users from '@/views/pages/users/users.vue'
import Users_List from '@/views/pages/users/users-list.vue'
import Roles_Permissions from '@/views/pages/users/roles-permissions.vue'
import Permissions from '@/views/pages/users/permissions.vue'
import Delete_Account from '@/views/pages/users/delete-account.vue'
import FileManager from '@/views/pages/application/files/file-manager.vue'
import Profile from '@/views/pages/pages/profile.vue'
import Places from '@/views/pages/pages/places/places.vue'
import Countries from '@/views/pages/pages/places/countries.vue'
import States from '@/views/pages/pages/places/states.vue'
import Success from '@/views/pages/pages/success.vue'
import SuccessTwo from '@/views/pages/pages/success-2.vue'
import SuccessThree from '@/views/pages/pages/success-3.vue'
import Activities from '@/views/pages/activities.vue'
import FileShared from '@/views/pages/application/files/file-shared.vue'
import FileDocument from '@/views/pages/application/files/file-document.vue'
import FileRecent from '@/views/pages/application/files/file-recent.vue'
import FileFavourites from '@/views/pages/application/files/file-favourites.vue'
import FileArchived from '@/views/pages/application/files/file-archived.vue'
import Settings from '@/views/pages/settings/settings.vue'
import General_Settings from '@/views/pages/settings/general-settings/general-settings.vue'
import Security_Settings from '@/views/pages/settings/general-settings/security-settings.vue'
import Notification from '@/views/pages/settings/general-settings/notification.vue'
import Connected_Apps from '@/views/pages/settings/general-settings/connected-apps.vue'
import System_Settings from '@/views/pages/settings/website-settings/system-settings.vue'
import Company_Settings from '@/views/pages/settings/website-settings/company-settings.vue'
import Localization_Settings from '@/views/pages/settings/website-settings/localization-settings.vue'
import Prefixes from '@/views/pages/settings/website-settings/prefixes.vue'
import Preference from '@/views/pages/settings/website-settings/preference.vue'
import Appearance from '@/views/pages/settings/website-settings/appearance.vue'
import Social_Authentication from '@/views/pages/settings/website-settings/social-authentication.vue'
import Language_Settings from '@/views/pages/settings/website-settings/language-settings.vue'
import Language_Settings_Web from '@/views/pages/settings/website-settings/language-settings-web.vue'
import Invoice_Settings from '@/views/pages/settings/app-settings/invoice-settings.vue'
import Printer_Settings from '@/views/pages/settings/app-settings/printer-settings.vue'
import Pos_Settings from '@/views/pages/settings/app-settings/pos-settings.vue'
import Custom_Fields from '@/views/pages/settings/app-settings/custom-fields.vue'
import Email_Settings from '@/views/pages/settings/system-settings/email-settings.vue'
import Sms_Gateway from '@/views/pages/settings/system-settings/sms-gateway.vue'
import Otp_Settings from '@/views/pages/settings/system-settings/otp-settings.vue'
import Gdpr_Settings from '@/views/pages/settings/system-settings/gdpr-settings.vue'
import Payment_Gateway_Settings from '@/views/pages/settings/financal-settings/payment-gateway-settings.vue'
import Bank_Settings_Grid from '@/views/pages/settings/financal-settings/bank-settings-grid.vue'
import Bank_Settings_List from '@/views/pages/settings/financal-settings/bank-settings-list.vue'
import Tax_Rates from '@/views/pages/settings/financal-settings/tax-rates.vue'
import Currency_Settings from '@/views/pages/settings/financal-settings/currency-settings.vue'
import Storage_Settings from '@/views/pages/settings/other-settings/storage-settings.vue'
import Ban_Ip_Address from '@/views/pages/settings/other-settings/ban-ip-address.vue'
import FileManagerDeleted from '@/views/pages/application/files/file-manager-deleted.vue'
import Pages from '@/views/pages/pages/pages.vue'
import Application from '@/views/pages/application/application.vue'
const routes = [
  {
    path: '/',
    name: 'sign-in',
    component: SignIn_3
  },
  {
    path: '/students',
    name: 'students',
    component: Category_List
  },
  {
    path: '/classes',
    name: 'classes',
    component: Sub_Categories
  },

  {
    path: '/success',
    name: 'success',
    component: Success
  },
  {
    path: '/success-2',
    name: 'success-2',
    component: SuccessTwo
  },
  {
    path: '/success-3',
    name: 'success-3',
    component: SuccessThree
  },
  {
    path: '/activities',
    name: 'activities',
    component: Activities
  },
  {
    path: '/pages',
    component: Pages,
    children: [
      { path: '', redirect: '/pages/profile' },
      { path: "profile", component: Profile },
      { path: "coming-soon", component: Coming_Soon },
      { path: "under-maintenance", component: Under_Maintenance },
      { path: "blank-page", component: Blank_Page },
    ]
  },
  {
    path: '/error',
    component: Error,
    children: [
      { path: '', redirect: '/error/error-404' },
      { path: "error-404", component: Error_404 },
      { path: "error-500", component: Error_500 },
    ]
  },
  {
    path: '/authentication',
    component: Pages,
    children: [
      { path: '', redirect: '/authentication/signin-2' },
      { path: "signin-2", component: SignIn_2 },
      { path: "signin-3", component: SignIn_3 },
      { path: "register-2", component: Register_2 },
      { path: "register-3", component: Register_3 },
      { path: "forgot-password-2", component: Forgot_Password_2 },
      { path: "forgot-password-3", component: Forgot_Password_3 },
      { path: "reset-password-2", component: Reset_Password_2 },
      { path: "reset-password-3", component: Reset_Password_3 },
      { path: "email-verification-2", component: Email_Verification_2 },
      { path: "email-verification-3", component: Email_Verification_3 },
      { path: "two-step-verification-2", component: Two_Step_Verification_2 },
      { path: "two-step-verification-3", component: Two_Step_Verification_3 },
      { path: "lock-screen", component: Lock_Screen },
    ]
  },

 
  {
    path: '/places',
    component: Places,
    children: [
      { path: '', redirect: '/places/countries' },
      { path: "countries", component: Countries },
      { path: "states", component: States },
    ]
  },
  {
    path: '/users',
    component: Users,
    children: [
      { path: '', redirect: '/users/users-list' },
      { path: "users-list", component: Users_List },
      { path: "roles-permissions", component: Roles_Permissions },
      { path: "permissions", component: Permissions },
      { path: "delete-account", component: Delete_Account },
    ]
  },

  {
    path: '/icons',
    component: Icons,
    children: [
      { path: '', redirect: '/icons/icon-fontawesome' },
      { path: "icon-fontawesome", component: UI_Iconfontawesome },
      { path: "icon-feather", component: UI_Iconfeather },
      { path: "icon-ionic", component: UI_Iconionic },
      { path: "icon-material", component: UI_Iconmaterial },
      { path: "icon-pe7", component: UI_Iconpe7 },
      { path: "icon-simpleline", component: UI_Iconsimpleline },
      { path: "icon-themify", component: UI_Iconthemify },
      { path: "icon-weather", component: UI_Iconweather },
      { path: "icon-typicon", component: UI_Icontypicon },
      { path: "icon-flag", component: UI_Iconflag },
    ]
  },
  {
    path: '/baseui',
    component: BaseUi,
    children: [
      { path: '', redirect: '/baseui/ui-alerts' },
      { path: "ui-alerts", component: UI_Alerts },
      { path: "ui-accordion", component: UI_Accordion },
      { path: "ui-avatar", component: UI_Avatar },
      { path: "ui-badges", component: UI_Badges },
      { path: "ui-borders", component: UI_Borders },
      { path: "ui-buttons", component: UI_Buttons },
      { path: "ui-buttons-group", component: UI_Buttons_group },
      { path: "ui-breadcrumb", component: UI_Breadcrumb },
      { path: "ui-cards", component: UI_Cards },
      { path: "ui-carousel", component: UI_Carousel },
      { path: "ui-colors", component: UI_Colors },
      { path: "ui-dropdowns", component: UI_Dropdowns },
      { path: "ui-grid", component: UI_Grid },
      { path: "ui-images", component: UI_Images },
      { path: "ui-lightbox", component: UI_Lightbox},
      { path: "ui-media", component: UI_Media},
      { path: "ui-modals", component: UI_Modals},
      { path: "ui-offcanvas", component: UI_Offcanvas},
      { path: "ui-pagination", component: UI_Pagination},
      { path: "ui-popovers", component: UI_Popovers},
      { path: "ui-progress", component: UI_Progress},
      { path: "ui-placeholders", component: UI_Placeholders},
      { path: "ui-rangeslider", component: UI_Rangeslider},
      { path: "ui-spinner", component: UI_Spinner},
      { path: "ui-sweetalerts", component: UI_Sweetalerts},
      { path: "ui-tooltips", component: UI_Tooltips},
      { path: "ui-typography", component: UI_Typography},
      { path: "ui-video", component: UI_Video},
    ]
  },
  {
    path: '/advancedui',
    component: Advancedui,
    children: [
      { path: '', redirect: '/advancedui/ui-ribbon' },
      { path: "ui-ribbon", component: UI_Ribbon },
      { path: "ui-clipboard", component: UI_Clipboard },
      { path: "ui-drag-drop", component: UI_Drag_Drop },
      { path: "ui-text-editor", component: UI_Text_Editor },
      { path: "ui-counter", component: UI_Counter },
      { path: "ui-scrollbar", component: UI_Scrollbar },
      { path: "ui-rating", component: UI_Rating },
      { path: "ui-stickynote", component: UI_Stickynote },
      { path: "ui-timeline", component: UI_Timeline }
    ]
  },
  {
    path: '/tables',
    component: Tables,
    children: [
      { path: '', redirect: '/tables/data-tables' },
      { path: "data-tables", component: Data_Tables },
      { path: "tables-basic", component: Tables_Basic }
    ]
  },
  {
    path: '/charts',
    component: Charts,
    children: [
      { path: '', redirect: '/charts/chart-apex' },
      { path: "chart-apex", component: Chartapex },
      { path: "chart-c3", component: Chartc3 },
      { path: "chart-flot", component: Chartflot },
      { path: "chart-js", component: Chartjs },
      { path: "chart-morris", component: Chartmorris }
    ]
  },
  {
    path: '/forms',
    component: Forms,
    children: [
      { path: '', redirect: '/forms/form-basic-inputs' },
      { path: "form-basic-inputs", component: Formbasicinput },
      { path: "form-checkbox-radios", component: Formcheckboxradios },
      { path: "form-grid-gutters", component: Formgridgutters },
      { path: "form-input-groups", component: FormInput },
      { path: "form-select", component: Formselect },
      { path: "form-mask", component: Formmask },
      { path: "form-fileupload", component: Formfileupload },
      { path: "form-horizontal", component: FormHorizontal },
      { path: "form-vertical", component: Formvertical },
      { path: "form-floating-labels", component: Formfloatinglabels },
      { path: "form-validation", component: Formvalidation },
      { path: "form-select2", component: Formselect2 },
      { path: "form-wizard", component: Formwizard },
    ]
  },
  {
    path: '/call',
    component: Call,
    children: [
      { path: '', redirect: '/call/video-call' },
      { path: "video-call", component: VideoCall },
      { path: "audio-call", component: AudioCall },
      { path: "call-history", component: CallHistory },
    ]
  },
  {
    path: '/dashboard',
    component: Dashboard,
    children: [
      { path: '', redirect: '/dashboard/admin-dashboard' },
      { path: "admin-dashboard", component: AdminDashboard },
      { path: "sales-dashboard", component: SalesDashboard },
    ]
  }
];

export const router = createRouter({
  // history: createWebHistory('/vuejs/template/'),
  history: createWebHistory('/'),
    linkActiveClass: 'active',
    routes,
}); 

router.beforeEach((to, from, next) => {
// Scroll to the top of the page
window.scrollTo({ top: 0, behavior: 'smooth' });
// Continue with the navigation
next();
});
